export default "__VITE_ASSET__Dyyv$G41__"